/*eslint-disable */
import LayerService from '@/services/layers/LayerService';

import store from '@/store/index';
import {
  LayerGroup, LeafletEvent, Marker, DivIcon,
  markerClusterGroup,
} from 'leaflet';
import { IFeatureCollection } from '@/interfaces/IFeatureCollection';
import AssetIconService from '@/services/AssetIconService';
import IFeature from '@/interfaces/IFeature';
import IPosition from '@/interfaces/IPosition';
import RedrawService from '../RedrawService';
import MapService from '../MapService';
import { toRaw } from 'vue';

export default class TrackStartPointsLayerService extends LayerService {
  // eslint-disable-next-line global-require
  onClick = (e: LeafletEvent, metaData: any, leafletMarker: Marker<any>): void => {
    const { isSelectedStartPoint} = store.state.tracks;
    const redrawService: RedrawService = new RedrawService(new MapService(store.state.leafletMapInstance));
    
    if (isSelectedStartPoint) {
      store.commit('switchOffSelectedStartPoint');
      store.commit('resetSelectedStartPointId');
      store.commit('updateTrackLines', []);
      redrawService.redrawMap();
    } else {
      store.commit('switchOnSelectedStartPoint');
      store.commit('setSelectedStartPointId', metaData.id);

      Promise.all([
        store.dispatch('updateTrackEndPoints', metaData.id),
      ])
        .then(() => {
          redrawService.redrawMap();
        })
        .catch();
    } 
  };

  redrawLayer = (): LayerGroup<any> => {
    const points: IFeatureCollection = {...store.state.trackStartPoints};
    const { selectedStartPointId} = store.state.tracks;

    if (selectedStartPointId) {
      points.features = points.features.filter((item: any) => item.properties.id === selectedStartPointId);
    }

    return this.generateMarkerClusterLayer(points);
  };

  protected generateMarkerClusterLayer = (positions: IFeatureCollection): LayerGroup => {
    const markerClusterGroupInstance = markerClusterGroup({
      showCoverageOnHover: false,
      maxClusterRadius: 40,
      iconCreateFunction: (cluster) => {
        const population = cluster.getChildCount();
        return new DivIcon({
          html: this.generateClusterHtml(population),
          className: 'custom-cluster-icon',
          iconSize: [this.clusterWidth, this.clusterHeight],
          iconAnchor: [this.clusterWidth / 2, this.clusterHeight / 2],
        });
      },
    });

    positions.features.forEach((feature: any) => {
      if (!feature.geometry) return;

      const { coordinates } = feature.geometry;
      const [lng, lat] = coordinates as Array<number>;

      const singleMarker = this.createMarker({ lat, lng }, feature);
      markerClusterGroupInstance.addLayer(toRaw(singleMarker));
    });

    return markerClusterGroupInstance;
  };

  generateClusterHtml(population: number) {
    const iconUrl = AssetIconService.getSvgMapIcon('cluster_way');
    const template: string = `
      <div
        class="map-cluster-custom-icon"
        style='background-image: url("${iconUrl}")'
      >
        <span class="cluster-counter">${population}</span>
      </div>
        `;

      return template;
  };

  protected generateHtmlPointTemplate = (metaData: any): string => {
    const iconUrl = AssetIconService.getSvgMapIcon('marker_way');
    const template: string = `
        <div
            class="map-simple-icon map-simple-icon--parking-meter"
            style='background-image: url("${iconUrl}")'
        >
        </div>
      `;

    return template;
  }
}
